import { gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import { useTheme } from '../../theme-context';
import './legend-dialog-style.scss';
import TierLine from './tier-line';

interface ILegendDialog {
    tiers: { name: string; color: string }[];
}

const LegendDialog = ({ tiers }: ILegendDialog): React.ReactElement => {
    const { getFont } = useTheme();

    return (
        <div className="legend-dialog">
            <div
                className={css({
                    background: 'white',
                    letterSpacing: '0',
                    padding: '16px',
                    borderRadius: '5px',
                })}
            >
                <div>
                    <p
                        className={css({
                            fontFamily: getFont('desktop/body/medium/bold')
                                .fontFamily,
                            fontWeight: getFont('desktop/body/medium/bold')
                                .fontWeight,
                            fontSize: getFont('desktop/body/medium/bold')
                                .fontSize,
                            lineHeight: `${
                                getFont('desktop/body/medium').lineHeightPx
                            }px`,
                        })}
                    >
                        {gettext('Legend')}
                    </p>
                </div>
                <div
                    className={css({
                        overflowY: 'auto',
                        maxHeight: '250px',
                    })}
                >
                    {tiers.map(({ name = '', color = 'white' }, index) => {
                        const content = (
                            <div
                                key={`tier-line-${index}`}
                                data-testid="tier-line"
                            >
                                <TierLine name={name} color={color} />
                            </div>
                        );

                        return content;
                    })}
                </div>
            </div>
        </div>
    );
};

export default LegendDialog;
